export const Dot = (): JSX.Element => <span style={{ opacity: 0.2 }}>•</span>;
